import React from 'react';
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion } from 'utils/types';
import css from './MobileFeedbackCell.css';
import { Table } from 'semantic-ui-react';
import InterventionIcon from "../common/InterventionIcon";
import NoteIcon from './NoteIcon';
import { uniqBy } from 'lodash';
import { anyQuestionHasComment } from 'utils/surveys';

const interventionCategories = ["flag", "referral", "kudos", "to-do"];

export default class MobileFeedbackCell extends React.Component {

  get checkedQuestions() {
    return this.props.availableQuestions.filter(question => this.props.isChecked(question.id));
  }

  get questionIcons() {
    const fullCheckedList = this.props.availableQuestions.filter(question => this.props.isChecked(question.id));
    const uniqueQuestionList = uniqBy(fullCheckedList, 'category');
    return (
      interventionCategories.map((item) => {
        const matchingQuestion = uniqueQuestionList.find(question => question.category === item);
        return (
          <li key={item} className={css['icon-grid']}>
            {matchingQuestion && <InterventionIcon category={matchingQuestion.category}/>}
          </li>
        )
      })
    )
  }

  get noteIcon() {
    return anyQuestionHasComment(this.checkedQuestions, this.props.answers) ? <NoteIcon isMobile={true}/> : null;
  }

  render() {
    return (
      <Table.Cell className={css['container']}>
        <ul>
          <li className={css['icon-grid']}>{this.noteIcon} </li>
          {this.questionIcons}
        </ul>
        <div className={css['toggle-grid']}> {this.props.plusButton}</div>
      </Table.Cell>
    );
  }
}

MobileFeedbackCell.propTypes = {
  availableQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  isChecked: PropTypes.func.isRequired,
  answers: PropTypes.array,
  plusButton: PropTypes.object
};
